export default "__VITE_ASSET__iXmRm6EB__"